import React from "react";
import { FaArrowDown, FaArrowUp, FaMinus, FaStar } from "react-icons/fa";
import { changeDirection, formatChange } from "../selectors";

const ICONS = {
  up: FaArrowUp,
  down: FaArrowDown,
  flat: FaMinus,
  new: FaStar,
};

/**
 * Period-over-period movement. "New" is its own state rather than a +100%
 * badge, because growth from a zero baseline has no honest percentage.
 *
 * The arrow carries the same meaning as the colour so the badge still reads
 * without relying on colour alone.
 */
export function TrendBadge({ pct, label, size = "md" }) {
  const direction = changeDirection(pct);
  const Icon = ICONS[direction];

  return (
    <span
      className={`ct-trend ct-trend--${direction} ct-trend--${size}`}
      title={label ? `${label}: ${formatChange(pct)} vs previous period` : undefined}
    >
      <Icon aria-hidden="true" />
      {formatChange(pct)}
    </span>
  );
}
